import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import useAuth from './useAuth';

export default function useCenterStudents({ adminView = false, page = 1, limit = 10, centerId = '' } = {}) {
    const { request } = useAuth();
    const queryClient = useQueryClient();

    const studentsQuery = useQuery({
        queryKey: ['centerStudents', adminView, page, limit, centerId],
        queryFn: () =>
            request
                .get(adminView ? '/centerStudent/all' : '/centerStudent/my', {
                    params: adminView
                        ? { page, limit, ...(centerId ? { centerId } : {}) }
                        : { page, limit },
                })
                .then((res) => res.data),
    });

    const addStudentMutation = useMutation({
        mutationFn: (formData) => request.post('/centerStudent/add', formData),
        onSuccess: () => queryClient.invalidateQueries({ queryKey: ['centerStudents'], exact: false }),
    });

    const updateStudentMutation = useMutation({
        mutationFn: (formData) => request.put('/centerStudent/update', formData),
        onSuccess: () => queryClient.invalidateQueries({ queryKey: ['centerStudents'], exact: false }),
    });

    const deleteStudentMutation = useMutation({
        mutationFn: (id) => request.delete('/centerStudent/delete', { data: { id } }),
        onSuccess: () => queryClient.invalidateQueries({ queryKey: ['centerStudents'], exact: false }),
    });

    return {
        students: studentsQuery?.data?.students || [],
        isStudentsLoading: studentsQuery.isLoading,
        totalStudents: studentsQuery?.data?.total || 0,

        addStudent: addStudentMutation.mutateAsync,
        isAddingStudent: addStudentMutation.isPending,

        updateStudent: updateStudentMutation.mutateAsync,
        isUpdatingStudent: updateStudentMutation.isPending,

        deleteStudent: deleteStudentMutation.mutateAsync,
        isDeletingStudent: deleteStudentMutation.isPending,
    };
}
